/**
 * Created: 2019-07-31 15:13
 * Author : biu
 * Email  : hezhou920@gmail.com
 * -----
 * Description: 路由鉴权组件
 */
import React, { PureComponent } from 'react'
import { connect } from 'dva'
import Redirect from 'umi/redirect'
import { Spin } from 'antd'
import pathToRegexp from 'path-to-regexp'
import Exception403 from '@/pages/Exception/403'

// 获取第一个有权限的路由
function getFirstPath(routeData, path = '') {
  if (!routeData) {
    return path
  }
  const route = routeData.find(item => item.authority)
  return getFirstPath(route.routes, route.path)
}

const getRouteAuthority = (path, routerData) => {
  if (path === '/' || path === '/personal') {
    return true
  }
  const findRoute = (path, routes, parentAuthority) => {
    if (!routes) {
      return
    }
    for (let i = 0; i < routes.length; i++) {
      const route = routes[i]
      if (route.path && pathToRegexp(route.path).test(path)) {
        // 自身权限没有配置时，使用父路由的权限
        if (route.authority == null && parentAuthority != null) {
          route.authority = parentAuthority
        }
        return route
      }
      if (route.routes) {
        const result = findRoute(path, route.routes, route.authority)
        if (result) {
          return result
        }
      }
    }
  }

  const route = findRoute(path, routerData)
  return !route || route.authority
}

@connect(({ login, menu }) => ({
  loginStatus: login.status,
  autoLoged: login.autoLoged,
  routerData: menu.routerData,
}))
class Authorized extends PureComponent {
  componentDidMount() {
    const { autoLoged, dispatch } = this.props
    if (!autoLoged) {
      dispatch({
        type: 'login/doAutoLogin',
      })
    }
  }

  render() {
    const { children, loginStatus, autoLoged, location, routerData, history } = this.props
    if (!autoLoged) {
      return <Spin />
    }
    if (loginStatus !== 'success') {
      return (
        <Redirect
          to={{
            pathname: '/user/login',
            search: history.location.search,
          }}
        />
      )
    }
    const authority = getRouteAuthority(location.pathname, routerData)
    // TODO: 这里的 location.pathname 修改为主界面的默认路由
    if (!authority && location.pathname === '/marketing/analysis') {
      const path = getFirstPath(routerData)
      if (path) {
        return <Redirect to={path} />
      }
    }
    return authority ? children : <Exception403 />
  }
}

export default Authorized
